import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logoPath from "../../assets/images/Logo.jpeg";
import AdminLogin from "./AdminLogin";
import "./Login.scss";
import TraineeLogin from "./TraineeLogin";
import TrainerLogin from "./TrainerLogin";
import { useSiteContext } from "../../contexts/SiteProvider";
import { LOGIN_IMAGE, LOGIN_IMAGE_2, LOGIN_IMAGE_3, LOGO } from "../../services/ImageService";
// You can set your logo as a variable here

const Login: React.FC = () => {
  const [role, setRole] = useState<"trainee" | "trainer" | "admin">("trainee"); // Default role is "trainee"
  const [title, setTitle] = useState<string>("KAVACH 4.0 ASSESSMENT TEST LOGIN"); // Default title
  const [isRoleChanged, setIsRoleChanged] = useState<boolean>(false); // To track if role was changed
  const navigate = useNavigate(); // To handle navigation (can be used to redirect after successful login)
  const { user, logout, settings } = useSiteContext();
  const handleRoleChange = (
    role: "trainee" | "trainer" | "admin",
    title: string
  ) => {
    setRole(role);
    setTitle(title);
    setIsRoleChanged(true); // Set role change flag
  };
  // console.log("data", settings)
  const handleBackToTrainee = () => {
    setRole("trainee");
    setTitle("KAVACH 4.0 ASSESSMENT TEST LOGIN");
    setIsRoleChanged(false);
  };
  const getSiteLogo = () => {
    if (settings && settings.st_site_login_logo) {
      let img_content = settings.st_site_login_logo;

      if (typeof img_content === "string") {
        try {
          img_content = JSON.parse(img_content);
        } catch (error) {
          return;
        }
      }

      if (img_content?.type && img_content?.content) {
        return `data:${img_content.type};base64,${img_content.content}`;
      }
    }

    return LOGO;
  };

  const getImage = ()=> {
    switch (role) {
      case "admin":
        return LOGIN_IMAGE_2;
      case "trainer":
        return LOGIN_IMAGE_3;
      
      default:
        return LOGIN_IMAGE;
    }
  };
  
 

  return (
    <>
      <div className="login-container">
        <div className="login-box">
          {/* Left side (Illustration) */}
          <div className="login-left">
            <img
              src={getImage()}
              alt="Login Illustration"
              className="login-image"
            />
          </div>

          {/* Right side (Login Form) */}
          <div className="login-right">
            <div className="">
              {" "}
              <img
                className="is-rounded logo"
                src={getSiteLogo()}
                alt=" "
              />{" "}
              <h1 className="title">{title}</h1>{" "}
            </div>
            {/* <h1 className="login-title">Sign In</h1> */}
            {/* <p className="login-subtitle">Unlock your world.</p> */}

            <div className="login-form">
              {role === "trainee" && <TraineeLogin />}
              {role === "trainer" && <TrainerLogin />}
              {role === "admin" && <AdminLogin />}
            </div>

            {/* Role Switch */}
            <div className="login-footer">
              {isRoleChanged ? (
                <button onClick={handleBackToTrainee} className="back-button">
                  Back to KAVACH 4.0 ASSESSMENT TEST LOGIN
                </button>
              ) : (
                <>
                  <button
                    onClick={() => handleRoleChange("trainer", "Trainer Login")}
                    className="footer-link"
                  >
                    {" "}
                    Login as Trainer{" "}
                  </button>{" "}
                  <button
                    onClick={() => handleRoleChange("admin", "Admin Login")}
                    className="footer-link"
                  >
                    {" "}
                    Login as Admin{" "}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
